import { useDevicesContext } from "@hireroo/app-helper/hooks";
import type { Widget } from "@hireroo/presentation";

export type GenerateLiveCodingDeviceSettingsPropsArgs = {};

export const useGenerateProps = (_args: GenerateLiveCodingDeviceSettingsPropsArgs): Widget.LiveCodingDeviceSettingsProps => {
  const { selectedVideoDeviceId, selectedAudioDeviceId, videoDevices, audioDevices, handleVideoChange, handleAudioChange } =
    useDevicesContext();

  return {
    videoInputSelector: {
      selectedDeviceId: selectedVideoDeviceId,
      devices: videoDevices,
      onChange: (newDeviceId: string) => {
        handleVideoChange(newDeviceId);
      },
    },
    audioInputSelector: {
      selectedDeviceId: selectedAudioDeviceId,
      devices: audioDevices,
      onChange: (newDeviceId: string) => {
        handleAudioChange(newDeviceId);
      },
    },
    // TODO: ノイズキャンセリングを実装する @shuheishintani
    // noiseCancellationSelector: {
    //   checked: false,
    //   onChange: () => {
    //     // toggleNoiseCancellation();
    //   },
    // },
  };
};
